import { BOM_FIELD_IDS, OPTIONAL_BOM_FIELD_IDS } from "./helpers";

const FIELD_DISPATCH = Object.fromEntries(
  [...BOM_FIELD_IDS, ...OPTIONAL_BOM_FIELD_IDS].map((field) => [
    field,
    ({ value, context }) => context.setBomField(field, value)
  ])
);

export const applyBomFieldUpdate = ({ fieldUpdate, context }) => {
  if (!fieldUpdate || !fieldUpdate.field) {
    return false;
  }
  const handler = FIELD_DISPATCH[fieldUpdate.field];
  if (!handler) {
    return false;
  }
  handler({ value: fieldUpdate.value, context });
  return true;
};
